<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
  <form @submit.prevent="onSubmit">
    <smart-input
        v-model="form.name"
        :error="inputErrors.name"
        name="name"
        label="שם משחק"
    />
    <div v-if="translationKey != ''" style="direction: ltr; text-align:left">
      Translation key: <strong>gameTypes.{{ translationKey }}</strong>
    </div>
    <organizations-select
        v-model="form.organizations"
        :multiple="true"
        hint="אלו מרכזים יורשו לייצר משחקים אלו?"
    />
    <languages-select v-model="currentLanguage" label="שפת המשחק" item-value="id" />
    <smart-input
        v-model="form.active"
        type="checkbox"
        name="active"
        :error="inputErrors.active"
        label="פעיל"
    />
    <v-switch
        v-model="form.can_live_edit"
        label="המשחק מאפשר עריכה בלייב"
    ></v-switch>
    <div v-if="!form.can_live_edit">
      <smart-input
          v-model="form.min_questions"
          type="number"
          :error="inputErrors.min_questions"
          label="מספר שאלות מינימלי"
          :min="0"
      />
      <h3>סוג השאלות במשחק:</h3>
      <smart-input
          v-model="form.category_and_difficulty"
          type="checkbox"
          name="active"
          :error="inputErrors.active"
          label="קושי וקטגוריה (מלך הטריויה)"
      />
      <smart-input
          v-model="form.is_default_only_one_true_answer"
          type="checkbox"
          name="active"
          :error="inputErrors.active"
          label="ברירת המחדל היא תשובה נכונה בלבד (ללא בחירה בין תשובות לא נכונות)"
      />
      <v-divider />

    </div>




    <v-row>
      <v-col cols="12">
        <h3>תמונה מרובעת</h3>
        <media-gallery-preview v-model="form.square_media_id" :image-url="type.square_logo" />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h3>תמונה עגולה</h3>
        <media-gallery-preview v-model="form.circle_media_id" :image-url="type.circle_logo" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3>תמונה claplab lite</h3>
        <media-gallery-preview v-model="lite_media_id" :image-url="type.lite_logo" />
      </v-col>
    </v-row>
		<v-textarea
			v-model="form.description"
			name="description"
			:error="inputErrors.description"
			label="תיאור המשחק"
		/>
		<smart-input type="text" v-model="form.help_link" name="help_link" label="קישור לדף עזרה למשחק" :error="inputErrors.help_link"/>

		<smart-input type="text" v-model="form.edit_iframe_override" name="edit_iframe_override" label="דריסת IFRAME עריכה" :error="inputErrors.iframe_url"/>
		<smart-input type="text" v-model="form.preview_iframe_override" name="preview_iframe_override" label="דריסת IFRAME תצוגה מקדימה" :error="inputErrors.iframe_url"/>

		<div v-if="form.json_path">
			<p>למשחק זה קיים כבר קובץ json</p>
			<v-btn
				small
				color="primary"
				class="mb-2"
				@click="showJsonUpload = !showJsonUpload"
			>
				<span>החלפת json</span>
			</v-btn>
			<v-btn
				small
				color="primary"
				class="mb-2"
				@click="downloadJson(form.json, form.json_path)"
			>
				<span>הורדת json</span>
			</v-btn>
		</div>
		<div v-if="showJsonUpload">
			<label for="json">בחרו קובץ JSON להעלאה</label>
			<v-file-input
				name="json_file"
				:error="inputErrors.json"
				accept=".json"
				:requied="form.can_live_edit"
			/>
			<p v-if="inputErrors.json" class="red--text">{{ inputErrors.json }}</p>
		</div>
		<div class="form-group mt-2">
			<v-btn :loading="inProgress" type="submit" color="success">
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import TypeModule from "src/store/modules/Type.module";
import FormView from "src/mixins/FormView";
import OrganizationsSelect from "dev/view/organizations/OrganizationsSelect";
import MediaGalleryPreview from "../../packages/gallery/MediaGalleryPreview";
import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";
import LanguagesSelect from "../languages/LanguagesSelect";

export default {
	name: "TypeForm",
	components: {LanguagesSelect, OrganizationsSelect, MediaGalleryPreview },
	props: [],
	data() {
		return {
      lite_media_id: null,
			form: {
				name: null,
				min_questions: 0,
				active: 1,
				logo: "",
				organizations: [],
				allowed_questions: [],
				description: "",
				can_live_edit: false,
				language_id: 1,
				edit_iframe_override: "",
				preview_iframe_override: ""
			},
			showJsonUpload: true
		};
	},
	mixins: [new FormView(TypeModule, "type", true)],
	computed: {
		isNew() {
			return !!this.type.id;
		},
		options() {
			return QuestionType.getAsOption();
		},
		currentLanguage() {
			return this.form.language_id == null ? '' : this.form.language_id
		},
		translationKey() {
			const typeName = this.form.name.trim();
			if(/[א-ת]/.test(typeName))
				return '';

			return typeName.replace(/\s+/g, '_').toLowerCase();
		}
	},
	created() {
		if (this.form.id) {
			this.fillAllowedQuestionsWithTypeData();
			this.showJsonUpload = false;
		}
	},

  methods: {
    getData(e) {
      const formData = new FormData(e.target);
      if (this.form.id) {
        formData.id = this.form.id;
      }
      if (this.lite_media_id)
        this.form.lite_media_id = this.lite_media_id
      else
        delete this.form.lite_media_id
      Object.keys(this.form).forEach(key => {
        const value = this.form[key];
        if (typeof value === "boolean") {
          formData.append(key, +value);
        } else if (Array.isArray(value)) {
          value.forEach(val => {
            formData.append(key + "[]", val);
          });
        } else {
          formData.append(key, value);
        }
      });

			return formData;
		},
		fillAllowedQuestionsWithTypeData() {
			this.form.allowed_questions = this.form.question_type.map(
				questionType => {
					return questionType.question_type;
				}
			);
		},
		downloadJson(jsonContent, filename) {
			var element = document.createElement('a');
			element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(jsonContent));
			element.setAttribute('download', filename);

			element.style.display = 'none';
			document.body.appendChild(element);

			element.click();

			document.body.removeChild(element);
		}
	}
};
</script>

<style></style>
